import { render, staticRenderFns } from "./TemperamentsView.vue?vue&type=template&id=33f3f8c0&scoped=true"
import script from "./TemperamentsView.vue?vue&type=script&lang=js"
export * from "./TemperamentsView.vue?vue&type=script&lang=js"
import style0 from "./TemperamentsView.vue?vue&type=style&index=0&id=33f3f8c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f3f8c0",
  null
  
)

export default component.exports